import React from 'react';
import {useTranslation} from 'react-i18next';

import {ButtonMore, Typography} from '@nur-portal/ui-kit';

import styles from './popular-news.module.css';

const PopularNews = ({newsData}) => {
  const {t} = useTranslation();

  if (newsData.isLoading) {
    return null;
  }

  if (!newsData?.data?.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Typography
        variant="title-17"
        className={styles.title}
      >
        {t('popularNews')}
      </Typography>
      <ul className={styles.list}>
        {newsData.data.map(({title, url}) => (
          <li className={styles.item} key={title}>
            <a href={url} key={title}>
              <Typography
                variant="title-14"
                className={styles.itemTitle}
              >
                {title}
              </Typography>
            </a>
          </li>
        ))}
      </ul>
      <a href="/latest" className={styles.more}>
        <ButtonMore hoverColor="#fff" color="#1e54b7">
          {t('allNews')}
        </ButtonMore>
      </a>
    </div>
  );
};

export {PopularNews};
